import { render, staticRenderFns } from "./LerAmostrasAP.vue?vue&type=template&id=30e4d033&"
import script from "./LerAmostrasAP.vue?vue&type=script&lang=js&"
export * from "./LerAmostrasAP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports